import { TileType } from '../types';

export interface CheeseItem {
  col: number;
  row: number;
  type: TileType.Cheese | TileType.PowerCheese;
  eaten: boolean;
}

export function initCheese(maze: number[][]): CheeseItem[] {
  const items: CheeseItem[] = [];
  for (let row = 0; row < maze.length; row++) {
    for (let col = 0; col < maze[row].length; col++) {
      const tile = maze[row][col];
      if (tile === TileType.Cheese || tile === TileType.PowerCheese) {
        items.push({
          col,
          row,
          type: tile as TileType.Cheese | TileType.PowerCheese,
          eaten: false,
        });
      }
    }
  }
  return items;
}

export function getCheeseAt(items: CheeseItem[], col: number, row: number): CheeseItem | undefined {
  return items.find(c => c.col === col && c.row === row && !c.eaten);
}
